/**
 * @generated SignedSource<<b697882a62eec19cb0a28674308f10f3>>
 * @relayHash 2a24468c466d8e9a73d581e3768dbb35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d01016327c806a0379196745d32fade48e4ff11a5890e82a8056269243acbe7d

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation$variables = {
  spaceId: string;
};
export type WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation$data = {
  readonly watchSpace: {
    readonly space: {
      readonly currentUser: {
        readonly isWatched: boolean;
      };
      readonly id: string | null | undefined;
    };
  } | null | undefined;
};
export type WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation = {
  response: WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation$data;
  variables: WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "currentUser",
            "value": true
          },
          {
            "kind": "Variable",
            "name": "spaceId",
            "variableName": "spaceId"
          }
        ],
        "kind": "ObjectValue",
        "name": "watchSpaceInput"
      }
    ],
    "concreteType": "WatchSpacePayload",
    "kind": "LinkedField",
    "name": "watchSpace",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isWatched"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2a24468c466d8e9a73d581e3768dbb35",
    "id": "d01016327c806a0379196745d32fade48e4ff11a5890e82a8056269243acbe7d",
    "metadata": {},
    "name": "WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation",
    "operationKind": "mutation",
    "text": "mutation WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation($spaceId:ID!){watchSpace(watchSpaceInput:{spaceId:$spaceId,currentUser:true}){space{id,currentUser{isWatched}}}}"
  }
};
})();

(node as any).hash = "66118bea4ceac3b38ba446d22355a1c9";

export default node;
